import React from 'react';
import { useRecoilValue } from 'recoil';
import { isAuthenticatedState, lightModeState } from '../../recoil/atoms';
import { Link } from 'react-router-dom';

const Footer = () => {
  const date = new Date();
  const year = date.getFullYear();
  const lightMode = useRecoilValue(lightModeState);
  const isAuthenticated = useRecoilValue(isAuthenticatedState);

  return (
    <footer
      className={`${
        lightMode ? 'text-black bg-gray-300' : 'text-white bg-black'
      } w-full sm:w-full body-font body shadow-inner p-3`}
    >
      <div className='flex items-center justify-between w-full'>
        <div className=' px-1 py-1 flex items-center sm:flex-row h-full'>
          <span className='ml-1 sm:ml-20 flex title-font font-medium items-center justify-center text-gray-900 hidden sm:inline'>
            <span
              className={`${
                !lightMode && 'text-white'
              } sm:ml-3 text-base sm:text-xl body`}
            >
              Asterisk Marketing
            </span>
          </span>
          <p
            className={`text-sm sm:ml-4 sm:pl-4 sm:border-l-2 ${
              lightMode ? 'border-gray-900' : 'border-gray-200'
            } sm:py-2 sm:mt-0 mt-1`}
          >
            © {year} Asterisk Client Portal — Developed By
            <span
              // href="https://jerichoirvin.site"
              className={`${
                lightMode
                  ? 'text-red-600 hover:text-red-400'
                  : 'text-gray-600 hover:text-gray-500'
              } ml-1 cursor-pointer`}
              // rel="noopener noreferrer"
              // target="_blank"
            >
              Makeforth
            </span>
          </p>
        </div>
        {isAuthenticated && (
          <Link
            to='/feedback'
            className={`hover:no-underline text-sm	${
              lightMode
                ? 'text-red-400 hover:text-red-500'
                : 'text-indigo-600 hover:text-indigo-500 '
            }`}
          >
            Send Feedback
          </Link>
        )}
      </div>
    </footer>
  );
};

export default Footer;
